import {
  deleteProduct as deleteProductRequest,
  reviewProduct,
  setProductShelf
} from '../api/admin'

const AUDIT_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
}

export default {
  data() {
    return {
      deletingId: null,
      detailVisible: false,
      current: null
    }
  },
  methods: {
    productTypeOf(row = {}) {
      const fallback = String(this.productType || 'SALE').trim().toUpperCase()
      const raw = String((row && row.type) || fallback).trim().toUpperCase()
      return raw === 'PURCHASE' ? 'PURCHASE' : 'SALE'
    },
    isPurchaseProduct(row = {}) {
      return this.productTypeOf(row) === 'PURCHASE'
    },
    productEntityName(row = {}) {
      return this.isPurchaseProduct(row) ? '求购' : '销售'
    },
    productTypeLabel(row = {}) {
      return this.productEntityName(row)
    },
    productTypeTag(row = {}) {
      return this.isPurchaseProduct(row) ? 'warning' : 'success'
    },
    showDetail(row) {
      this.current = row
      this.detailVisible = true
    },
    formatDisplayProductId(value) {
      const raw = String(value || '').trim()
      if (!raw) return '-'
      if (/^\d+$/.test(raw)) return raw
      const matched = raw.match(/(?:^|[_-])(\d+)$/)
      return matched ? matched[1] : raw
    },
    normalizeAuditStatus(row = {}) {
      const raw = String((row && row.auditStatus) || '').trim().toUpperCase()
      if (!raw) return AUDIT_STATUS.PENDING
      if (raw === AUDIT_STATUS.PENDING || raw === AUDIT_STATUS.REJECTED || raw === AUDIT_STATUS.APPROVED) {
        return raw
      }
      return AUDIT_STATUS.PENDING
    },
    isPending(row) {
      return this.normalizeAuditStatus(row) === AUDIT_STATUS.PENDING
    },
    isApproved(row) {
      return this.normalizeAuditStatus(row) === AUDIT_STATUS.APPROVED
    },
    isRejected(row) {
      return this.normalizeAuditStatus(row) === AUDIT_STATUS.REJECTED
    },
    auditLabel(row) {
      const status = this.normalizeAuditStatus(row)
      if (status === AUDIT_STATUS.PENDING) return '待审批'
      if (status === AUDIT_STATUS.REJECTED) return '已驳回'
      return '已通过'
    },
    auditTagType(row) {
      const status = this.normalizeAuditStatus(row)
      if (status === AUDIT_STATUS.PENDING) return 'warning'
      if (status === AUDIT_STATUS.REJECTED) return 'danger'
      return 'success'
    },
    async approveProduct(row) {
      try {
        const updated = await reviewProduct(row.id, true, '')
        this.$message.success('审批通过成功')
        this.applyUpdatedProduct(updated)
      } catch (error) {
        this.$message.error(error.message || '审批失败')
      }
    },
    rejectProduct(row) {
      const entityName = this.productEntityName(row)
      this.$prompt('请输入驳回原因（可选）', `驳回${entityName}`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '例如：图片不清晰、信息不完整'
      }).then(async ({ value }) => {
        try {
          const updated = await reviewProduct(row.id, false, value || '')
          this.$message.success('已驳回')
          this.applyUpdatedProduct(updated)
        } catch (error) {
          this.$message.error(error.message || '驳回失败')
        }
      }).catch(() => {})
    },
    toggleShelf(row) {
      const nextOnShelf = !row.onShelf
      const actionText = nextOnShelf ? '上架' : '下架'
      const entityName = this.productEntityName(row)
      this.$confirm(`确认${actionText}该${entityName}吗？`, '提示', { type: 'warning' })
        .then(async () => {
          const updated = await setProductShelf(row.id, nextOnShelf)
          this.$message.success(`${actionText}成功`)
          this.applyUpdatedProduct(updated)
        })
        .catch(() => {})
    },
    deleteProduct(row) {
      const entityName = this.productEntityName(row)
      if (!row || !row.id) {
        this.$message.warning(`${entityName}信息无效`)
        return
      }
      if (row.onShelf) {
        this.$message.warning(`该${entityName}正在上架中，请先下架后再删除`)
        return
      }
      const displayId = this.formatDisplayProductId(row.id)
      this.$confirm(
        `${entityName}ID：${displayId}，标题：${row.name || '-'}。确认删除吗？删除后将清理相关收藏和浏览记录，操作不可恢复。`,
        `删除${entityName}`,
        {
          type: 'warning',
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          confirmButtonClass: 'el-button--danger'
        }
      ).then(async () => {
        this.deletingId = row.id
        try {
          await deleteProductRequest(row.id)
          this.products = this.products.filter(item => item.id !== row.id)
          if (this.current && this.current.id === row.id) {
            this.current = null
            this.detailVisible = false
          }
          if (typeof this.onProductDeleted === 'function') {
            await this.onProductDeleted(row)
          }
          this.$message.success('删除成功')
        } catch (error) {
          this.$message.error(error.message || '删除失败')
        } finally {
          this.deletingId = null
        }
      }).catch(() => {})
    },
    applyUpdatedProduct(updated = {}) {
      this.products = this.products.map(item => (item.id === updated.id ? { ...item, ...updated } : item))
      if (this.current && this.current.id === updated.id) {
        this.current = { ...this.current, ...updated }
      }
    },
    resolveSpecification(row = {}) {
      const specs = Array.isArray(row.specifications) ? row.specifications : []
      const matched = specs.find(item => {
        const name = String((item && item.name) || '').trim()
        return name === '规格' || name === '包装规格'
      })
      const value = String((matched && matched.value) || '').trim()
      return value || '-'
    },
    formatPrice(value) {
      const number = Number(value)
      if (!Number.isFinite(number) || number <= 0) return ''
      const text = Number.isInteger(number) ? `${number}` : `${String(number).replace(/\.?0+$/, '')}`
      return `${text}元`
    },
    formatQuantity(value) {
      const number = Number(value)
      if (!Number.isFinite(number) || number <= 0) return '-'
      return `${Math.floor(number)}吨`
    },
    resolveDetailImages(row = {}) {
      const images = Array.isArray(row.images) ? row.images.filter(Boolean).slice(0, 3) : []
      if (images.length > 0) return images
      return row.image ? [row.image] : []
    }
  }
}
